import ImportDataIcon from "@mui/icons-material/ExitToAppRounded";
import { Avatar } from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import ExcelIcon from "@entrilia/shared/icons/fileFormats/ExcelIcon";
import PassthroughLogo from "../../../images/passthrough.png";
import { pageRoutes } from "../../../routes";
import { getReferrerLocationState } from "../../../utilities/navigationHelper";
import PassthroughDataProviderDialog from "./providers/passthrough/PassthroughDataProviderDialog";

interface Props {
  hasAccessToCsvImport: boolean;
  hasAccessToPassthroughImport: boolean;
}

const ImportDataPageActions = ({ hasAccessToCsvImport, hasAccessToPassthroughImport }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [showPassthroughDialog, setShowPassthroughDialog] = useState(false);

  const handleImportFromCsvClick = () => {
    navigate(`${pageRoutes.importCsvData}`, { state: getReferrerLocationState(location) });
  };

  const handleImportFromPassthroughClick = () => {
    setShowPassthroughDialog(true);
  };

  const items = [];

  if (hasAccessToCsvImport) {
    items.push({
      label: "Import from CSV",
      onClick: handleImportFromCsvClick,
      icon: <ExcelIcon />,
    });
  }

  if (hasAccessToPassthroughImport) {
    items.push({
      label: "Import from Passthrough",
      onClick: handleImportFromPassthroughClick,
      icon: <Avatar src={PassthroughLogo} variant="square" sx={{ width: 20, height: 20 }} />,
    });
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      <ActionsMenuButton text="Import Data" variant="contained" icon={<ImportDataIcon />} items={items} />
      {showPassthroughDialog && <PassthroughDataProviderDialog onClose={() => setShowPassthroughDialog(false)} />}
    </>
  );
};

export default ImportDataPageActions;
